import Icon from '@components/icon/Icon';
import { mdiDotsVertical as menuIcon } from '@mdi/js';

const ActionMenuButton = () => (
  <button className='action-menu-button' type='button' tabIndex={-1}>
    <Icon focusable={false} className='action-menu-icon' path={menuIcon} size={'1rem'} />
    {<span className='action-menu-label'>Actions</span>}
  </button>
);

export default ActionMenuButton;
